import { memo } from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import StyledContainer from '/shared/styled/StyledContainer';
import StyledInner from '/shared/styled/StyledInner';
import StyledHeaderLogo from '/business/shared/components/widgets/header/__styled__/StyledHeaderLogo';

import useAppContext from '/business/shared/hooks/useAppContext';

function HeaderLogo() {
  const { images } = useAppContext();
  const logoImage = images?.logoImage ?? '';
  const logoImageMaxHeight = images?.logoImageMaxHeight;

  const { t } = useTranslation();
  return (
    <StyledHeaderLogo id="headerTopId">
      <StyledContainer $centred>
        <StyledInner $business>
          <NavLink end to="/">
            <img
              src={logoImage}
              alt={t('business:Header.logoAltText', 'Castrol and Target Neutral logo')}
              height={logoImageMaxHeight}
            />
          </NavLink>
        </StyledInner>
      </StyledContainer>
    </StyledHeaderLogo>
  );
}

export default memo(HeaderLogo);
